const space = [0, 5, 10, 20, 30, 40];
const fontSizes = [7, 11, 12, 13, 15, 26];
const colors = {
  Orange: '#ff780d',
  Blue: '#1b82be',
  'Neutral Blue': '#597089',
  'Mid Blue': '#529eca',
  'Light Blue': '#dde9f7',
  'Light Blue 2': '#f0f6fa',
  'Dark Blue': '#1573aa',
  'Dark Neutral 1': '#3c4757',
  'Mid Neutral 1': '#6e767f',
  'Mid Neutral 2': '#9ba1ae',
  'Mid Neutral 3': '#d7dbe2',
  'Light Neutral 1': '#e3e5ea',
  'Light Neutral 2': '#f4f5f7',
  'Light Neutral 3': '#f9f9fa',
  Yellow: '#fab666',
  'Dark Yellow': '#e58d27',
  'Light Yellow': '#fff8f0',
  Red: '#eb5757',
  'Light Red': '#fef7f7',
  Green: '#2ea970',
  'Dark Green': '#129558',
  White: '#ffffff',
  Carat: '#cfd4dc',
};

const baseTheme = {
  breakpoints: ['600px', '900px', '1200px'],
  space: {
    ...space,
    xxsmall: space[1],
    xsmall: space[2],
    small: space[3],
    medium: space[4],
    large: space[5],
    gutter: space[3],
  },
  sizes: {},
  colors: {
    ...colors,
    link: colors.Blue,
    background: colors.White,
    backgroundAccent: colors['Light Neutral 3'],
    backgroundDisabled: colors['Light Neutral 2'],
    foreground: colors['Dark Neutral 1'],
    tooltipForeground: colors.White,
    tooltipBackground: colors['Dark Neutral 1'],
    foregroundAccent: colors['Mid Neutral 1'],
    foregroundDisabled: colors['Mid Neutral 3'],
    border: colors['Mid Neutral 3'],
    borderActive: colors['Mid Neutral 2'],
    borderAccent: colors['Light Neutral 1'],
    borderDisabled: colors['Mid Neutral 3'],
    borderFocus: colors.Blue,
    borderError: colors.Red,
    error: colors.Red,
    placeholder: colors['Mid Neutral 2'],
    divider: colors['Mid Neutral 3'],
  },
  fontSizes: {
    ...fontSizes,
    micro: fontSizes[0],
    xxsmall: fontSizes[1],
    xsmall: fontSizes[2],
    small: fontSizes[3],
    standard: fontSizes[3],
    medium: fontSizes[4],
    large: fontSizes[5],
    heading: [0, fontSizes[5], fontSizes[4]],
    input: fontSizes[3],
  },
  fontWeights: {
    standard: 400,
    display: 400,
    regular: 400,
    bold: 600,
  },
  lineHeights: {
    standard: 1.5,
    display: 1.2,
  },
  fonts: {
    standard:
      '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
    display:
      '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  fontMeta: {
    standard: {
      capHeightScale: 0.72,
      descenderHeightScale: 0.124,
    },
    display: {
      capHeightScale: 0.72,
      descenderHeightScale: 0.124,
    },
  },
  radii: {
    xsmall: 3,
    small: 4,
    medium: 6,
    button: 6,
    input: 6,
    card: 6,
    modal: 6,
  },
  borderWidths: {
    divider: '1px',
    input: '1px',
    button: '1px',
  },
  shadows: {
    focus: `0 0 0 1px ${colors.Blue}, 0 0 0 5px rgba(27, 130, 190, .3)`,
  },
  components: {
    Container: {
      padding: [space[2], space[3]],
      width: 1140,
    },
    Modal: {
      // sizes: {
      //   small: { width: '440px' },
      //   medium: { width: '660px' },
      //   large: { width: '990px' },
      // },
    },
    Button: {
      defaultIntentForAppearance: {
        primary: 'info',
        secondary: 'neutral',
        minimal: 'neutral',
      },
      intents: {
        info: {
          color: colors.Blue,
          hover: colors['Dark Blue'],
        },
        positive: {
          color: colors.Green,
          hover: colors['Dark Green'],
        },
        danger: {
          color: colors.Red,
          hover: '#e84040',
        },
        neutral: {
          color: colors['Dark Neutral 1'],
          hover: '#2f3743',
          minimal: colors['Mid Neutral 2'],
          minimalHover: colors['Mid Neutral 1'],
          minimalActive: colors.Blue,
        },
        muted: {
          color: colors['Dark Neutral 1'],
          hover: '#2f3743',
          background: colors['Light Blue'],
          backgroundHover: '#c8dcf2',
          foregroundOnColor: colors['Neutral Blue'],
          minimal: colors['Mid Neutral 1'],
          minimalHover: colors['Dark Neutral 1'],
        },
      },
    },
    Panel: {
      intents: {
        warning: {
          backgroundColor: colors['Light Yellow'],
          border: 'transparent',
        },
        neutral: {
          backgroundColor: colors.White,
          headerBackgroundColor: colors['Light Neutral 3'],
          border: colors['Light Neutral 1'],
        },
      },
    },
  },
};

export default baseTheme;
